import { gql, TypedDocumentNode } from '@apollo/client'
import { QueryPageableRequest, QueryPageableResponse } from '../../../core/type'
import { TicketCategory } from '../type/ticket-category'
import { Identity } from '../../../core/type'

export const GetTicketCategoriesQuery: TypedDocumentNode<
  QueryPageableResponse<TicketCategory, 'ticketCategoriesFind'>,
  QueryPageableRequest<{id?: number, title?: string}>
> = gql`
    query GetTicketCategoriesQuery($request: TicketCategoryFindRequest!) {
        ticketCategoriesFind(request: $request) {
            data {
                id
                title
            }
            count
        }
    }
`

export const CreateTicketCategoryMutation: TypedDocumentNode<void, {dto: {title: string}}> = gql`
    mutation CreateTicketCategory($dto: TicketCategoryInput!) {
        ticketCategoryCreate(dto: $dto)
    }
`

export const UpdateTicketCategoryMutation: TypedDocumentNode<void, {id: number, dto: {title: string}}> = gql`
    mutation UpdateTicketCategory($id: Int!, $dto: TicketCategoryInput!) {
        ticketCategoryUpdate(id: $id, dto: $dto)
    }
`

export const DeleteTicketCategoryMutation: TypedDocumentNode<void, {id: number}> = gql`
    mutation DeleteTicketCategory($id: Int!) {
        ticketCategoryDelete(id: $id)
    }
`

export const GetAllTicketCategoriesQuery: TypedDocumentNode<
  QueryPageableResponse<TicketCategory, 'ticketCategoriesFind'>,
  QueryPageableRequest<{}>
> = gql`
    query GetAllTicketCategories {
        ticketCategoriesFind(request: { take: 1000, skip: 0 }) {
            data {
                id
                title
            }
            count
        }
    }
`

